import { TranslatableError } from "./translatable-error";

export class EntityNotFoundError extends TranslatableError {
  constructor(entityType: string) {
    super(`${entityType} not found`, entityType);
    this.name = "EntityNotFoundError";
  }
}
